import { Page } from 'layouts/Page';
import { FC } from 'react';
import { EprPpwr } from 'components/EprPpwr';

export const EprPpwrPage: FC = () => {
	return (
		<Page title="EPR/PPWR – EAS Dashboard">
			<EprPpwr />
		</Page>
	);
};
